import { ShortcutGroup } from "./ShortcutsOffcanvas.d";

export const shortcutGroups: ShortcutGroup[] = [
  {
    id: "GLOBAL",
    paths: [],
    shortcuts: [
      { id: "TOGGLE_HELP", keys: ["?"] },
      { id: "SEARCH", keys: ["CONTROL", "K"], permission: { methods: ["GET"], route: "/search" } },
      { id: "MY_PROFILE", keys: ["SHIFT", "P"] },
    ],
  },
  {
    id: "USER",
    permission: { methods: ["GET"], route: "/users/*" },
    paths: ["/user/:user_id", "/user-by-email/:email"],
    shortcuts: [
      { id: "COPY_USER", keys: ["SHIFT", "C"] },
      { id: "LOGIN_AS", keys: ["SHIFT", "L"], permission: { methods: ["GET"], route: "/auth/login-as/*" } },
      { id: "SHOW_IDS", keys: ["HOLD_SHIFT"], permission: { methods: ["GET"], route: "/users/*/lessons" } },
    ],
  },
  {
    id: "COHORT",
    permission: { methods: ["GET"], route: "/cohorts/*" },
    paths: ["/cohort/:cohort_id"],
    shortcuts: [
      { id: "COPY_COHORT", keys: ["SHIFT", "C"] },
      { id: "SHOW_COUNTS", keys: ["HOLD_SHIFT"] },
    ],
  },
  {
    id: "CORRECTION",
    permission: { methods: ["GET"], route: "/evaluations/attempts/*/details" },
    paths: ["/evaluation-attempt/:evaluation_attempts_id"],
    shortcuts: [{ id: "COPY_CORRECTION", keys: ["SHIFT", "C"] }],
  },
  {
    id: "PROJECT",
    permission: { methods: ["GET"], route: "/projects/*" },
    paths: ["/project/:project_id"],
    shortcuts: [{ id: "COPY_PROJECT", keys: ["SHIFT", "C"] }],
  },
  {
    id: "MEETING",
    permission: { methods: ["GET"], route: "/meetings/*" },
    paths: ["/meeting/:meeting_id"],
    shortcuts: [{ id: "COPY_MEETING", keys: ["SHIFT", "C"] }],
  },
];
